import { $ } from "./dom.js";

export function closeDrawer() {
  const drawer = $(".drawer");
  if (!drawer?.classList.contains("is-open")) return;

  drawer.classList.remove("is-open");
  drawer.setAttribute("aria-hidden", "true");
  document.body.classList.remove("menu-open");
  const menuBtn = $(".menu-toggle");
  menuBtn?.setAttribute("aria-expanded", "false");
  menuBtn?.setAttribute("aria-label", "Otwórz menu");
}

export function initMenu() {
  const drawer = $(".drawer");
  const menuBtn = $(".menu-toggle");
  const docsToggle = $(".drawer-docs-toggle");
  const docsPanel = $(".drawer-docs");
  const dropdown = $(".dropdown");
  const dropdownBtn = dropdown ? $(".nav-btn", dropdown) : null;

  function closeDropdown() {
    if (!dropdown || !dropdownBtn) return;
    dropdown.classList.remove("is-open");
    dropdownBtn.classList.remove("is-open");
    dropdownBtn.setAttribute("aria-expanded", "false");
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("menu-open");
    menuBtn?.setAttribute("aria-expanded", "true");
    menuBtn?.setAttribute("aria-label", "Zamknij menu");
  }

  menuBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    drawer?.classList.contains("is-open") ? closeDrawer() : openDrawer();
  });

  $(".drawer__backdrop")?.addEventListener("click", closeDrawer);
  $(".drawer__close")?.addEventListener("click", closeDrawer);

  docsToggle?.addEventListener("click", () => {
    if (!docsPanel) return;
    const open = !docsPanel.classList.contains("is-open");
    docsPanel.classList.toggle("is-open", open);
    docsToggle.setAttribute("aria-expanded", String(open));
  });

  drawer?.querySelectorAll(".drawer__panel a[href]").forEach((link) => {
    link.addEventListener("click", () => closeDrawer());
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (dropdown?.classList.contains("is-open")) {
      closeDropdown();
      return;
    }
    closeDrawer();
  });

  if (dropdown && dropdownBtn) {
    dropdownBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = !dropdown.classList.contains("is-open");
      dropdown.classList.toggle("is-open", open);
      dropdownBtn.classList.toggle("is-open", open);
      dropdownBtn.setAttribute("aria-expanded", String(open));
    });

    dropdown.querySelectorAll(".dropdown__menu a").forEach((link) => {
      link.addEventListener("click", () => closeDropdown());
    });

    document.addEventListener("click", (e) => {
      if (dropdown.contains(e.target)) return;
      closeDropdown();
    });
  }
}
